export const FETCH_REPORTS_DAILY_TABLE_START = "FETCH_REPORTS_DAILY_TABLE_START";
export const FETCH_REPORTS_DAILY_TABLE_SUCCESS = "FETCH_REPORTS_DAILY_TABLE_SUCCESS";
export const FETCH_REPORTS_DAILY_TABLE_FAIL = "FETCH_REPORTS_DAILY_TABLE_FAIL";

export const SET_CHECKBOX = "SET_CHECKBOX";

export const SELECT_ALL_CHECKBOX = "SELECT_ALL_CHECKBOX";
